import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react'
import useTranslations from '../Translations/useTranslations';
import award2 from "../../Assest/Images/award2.svg";
import AnimationSlideRight from "../../Animation/AnimationSlideRight";
import AnimationSlideLeft from "../../Animation/AnimationSlideLeft";

const Awardpart = () => {
    const isMobile = useMediaQuery("(max-width:600px)");
  const { translations } = useTranslations();
    const styles = {
        container: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f9f5ff",
          padding: isMobile ? "" : "2rem 4rem",
        },
    
        heading: {
          fontSize: isMobile ? "24px" : "32px",
          fontWeight: "bold",
          color: "#000",
          marginBottom: "10px",
          textAlign: "left",
        },
        subheading: {
          fontSize: isMobile ? "14px" : "16px",
          fontWeight: "bold",
          color: "#333",
          marginBottom: "20px",
          textAlign: "left",
        },
    
        button: {
          background: "linear-gradient(90deg, #4A7BA8, #244C77)",
          color: "#fff",
          fontSize: isMobile ? "14px" : "18px",
          fontWeight: "bold",
          textTransform: "none",
          padding: "8px 50px",
          borderRadius: "10px",
          marginTop: "1rem",
        },
      };
  return (
    <div style={{paddingTop:"6rem", minHeight:"60vh"}} >
     <Box sx={styles.container}>
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AnimationSlideLeft duration={1.4} rootMargin={"-10px"}>
              <Box sx={{ p: 4 }}>
                <Typography sx={styles.heading}>{translations.Award}</Typography>
                <Typography sx={styles.subheading}>
                {translations.aboutAward}
                </Typography>
              </Box>
            </AnimationSlideLeft>
          </Grid>

          <Grid item xs={12} md={6} p={2}>
            <AnimationSlideRight duration={1.4} rootMargin={"-10px"}>
              <Box sx={styles.imageSection}>
                <img
                  src={award2}
                  width={isMobile ? "60%" : "60%"}
                  alt="Contact Illustration"
                />
              </Box>
            </AnimationSlideRight>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

export default Awardpart
